import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { tripAPI } from '../../api/trips';
import { Package } from 'lucide-react';

export const PendingReceiptWidget: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPendingReceipts = async () => {
      try {
        const result = await tripAPI.getPendingReceipt();
        setCount(result.count);
      } catch (error) {
        console.error('Failed to fetch pending receipts:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPendingReceipts();
  }, []);

  if (loading) {
    return (
      <div className="rounded-lg border bg-white p-6 shadow-sm">
        <div className="animate-pulse">
          <div className="h-4 w-32 rounded bg-gray-200"></div>
          <div className="mt-2 h-8 w-20 rounded bg-gray-200"></div>
        </div>
      </div>
    );
  }

  if (count === 0) {
    return null;
  }

  return (
    <div
      onClick={() => navigate('/trips?warehouseReceiptStatus=PENDING')}
      className="cursor-pointer rounded-lg border bg-white p-6 shadow-sm transition-shadow hover:shadow-md"
    >
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-gray-500">
            {t('warehouse.pendingReceipt.title')}
          </p>
          <p className="mt-2 text-3xl font-bold text-orange-600">{count}</p>
          <p className="mt-1 text-sm text-gray-500">
            {t('warehouse.pendingReceipt.description')}
          </p>
        </div>
        <div className="rounded-full bg-orange-100 p-3">
          <Package className="h-8 w-8 text-orange-600" />
        </div>
      </div>
    </div>
  );
};
